import get from 'lodash.get';

const getFontPairTemplate = (state) =>
  get(state, 'ws.template.meta.customization.fontPairTemplate', '');

export default getFontPairTemplate;
